<template>
  <div class="login-page container-fluid min-vh-100">
    <div class="row min-vh-100 align-items-center">
      <div class="col-12 col-lg-8 d-flex align-items-center justify-content-center">
        <div class="login-card w-100 mx-auto">
          <div class="mb-4 d-flex align-items-center gap-2">
            <img src="../img/logotipo-icon.png" height="38" alt="WiseCalc" />
          </div>

          <h4 class="fw-bold mb-1"><b>Defina sua senha</b></h4>
          <p class="text-muted mb-4">Olá, {{ nome }}. Crie uma senha para acessar sua conta também por e-mail.</p>

          <form @submit.prevent="definirSenha">
            <label class="form-label">CPF *</label>
            <input v-model="cpf" type="text" class="form-control mb-3" required />

            <label class="form-label">Empresa</label>
            <input v-model="empresa" type="text" class="form-control mb-3" />

            <label class="form-label">Nova senha</label>
            <div class="campo-senha mb-3">
              <img
                src="../img/block-blue-icon.png"
                class="icone cadeado"
                alt="Senha"
              />
              <input
                v-model="senha"
                :type="mostrarSenha ? 'text' : 'password'"
                class="form-control input-senha"
                minlength="8"
                required
              />
              <img
                src="../img/eye-icon.png"
                class="icone olho"
                alt="Mostrar senha"
                @click="mostrarSenha = !mostrarSenha"
              />
            </div>

            <label class="form-label">Confirmar senha</label>
            <div class="campo-senha mb-4">
              <img
                src="../img/block-blue-icon.png"
                class="icone cadeado"
                alt="Senha"
              />
              <input
                v-model="confirmarSenha"
                :type="mostrarConfirmarSenha ? 'text' : 'password'"
                class="form-control input-senha"
                minlength="8"
                required
              />
              <img
                src="../img/eye-icon.png"
                class="icone olho"
                alt="Mostrar senha"
                @click="mostrarConfirmarSenha = !mostrarConfirmarSenha"
              />
            </div>

            <button type="submit" class="btn btn-primary botao-azul w-100" :disabled="carregando">
              {{ carregando ? 'Salvando...' : 'Salvar senha e continuar' }}
            </button>
          </form>
        </div>
      </div>

      <div class="col-lg-4 d-none d-lg-flex login-banner p-0">
        <img src="../img/banner.svg" class="login-banner-img" alt="Banner" />
      </div>
    </div>

    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />
  </div>
</template>

<script>
import AlertModal from '@/componentesTelas/AlertModal.vue';
import { setUsuario } from '@/utils/authStorage';

export default {
  name: 'DefinirSenhaGoogle',
  components: { AlertModal },
  data() {
    return {
      token: '',
      nome: 'usuário',
      cpf: '',
      empresa: '',
      senha: '',
      confirmarSenha: '',
      mostrarSenha: false,
      mostrarConfirmarSenha: false,
      carregando: false,
      alertModal: { visible: false, title: '', message: '', type: 'info' }
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.token = params.get('token') || '';
    this.nome = params.get('nome') || 'usuário';

    if (!this.token) {
      this.abrirAlert('Sistema', 'O link para definir a senha é inválido ou expirou.', 'error');
    }
  },
  methods: {
    abrirAlert(title, message, type = 'info') {
      this.alertModal = { visible: true, title, message, type };
    },
    fecharAlert() {
      this.alertModal.visible = false;
    },
    async definirSenha() {
      if (this.senha.length < 8) {
        this.abrirAlert('Sistema', 'A senha deve ter no mínimo 8 caracteres.', 'error');
        return;
      }
      if (this.senha !== this.confirmarSenha) {
        this.abrirAlert('Sistema', 'As senhas não coincidem.', 'error');
        return;
      }

      this.carregando = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_BACKEND_URL}/auth/google/set-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            token: this.token,
            cpf: this.cpf,
            empresa: this.empresa,
            senha: this.senha
          })
        });
        const data = await response.json();

        if (!response.ok) {
          this.abrirAlert('Sistema', data.message || 'Não foi possível definir sua senha.', 'error');
          return;
        }

        const nomeNormalizado = (() => {
          if (typeof data.nome !== 'string') return data.nome;
          try {
            return decodeURIComponent(escape(data.nome));
          } catch (error) {
            return data.nome;
          }
        })();

        setUsuario({
          nome: nomeNormalizado,
          email: data.email,
          tipo: data.tipo
        });

        if (data.novoCadastro) {
          const checkoutResponse = await fetch(`${process.env.VUE_APP_BACKEND_URL}/criar-checkout`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: data.email })
          });
          const checkoutData = await checkoutResponse.json();

          if (!checkoutResponse.ok || !checkoutData.url) {
            throw new Error(checkoutData.erro || 'Não foi possível iniciar o checkout.');
          }

          window.location.href = checkoutData.url;
          return;
        }

        this.$router.replace('/app');
      } catch (error) {
        this.abrirAlert('Sistema', 'Erro ao definir sua senha. Tente novamente.', 'error');
      } finally {
        this.carregando = false;
      }
    }
  }
};
</script>

<style scoped>
.login-page { background: #ffffff; }
.login-card { max-width: 420px; padding: 32px; }
.login-banner { height: 100vh; justify-content: flex-end; }
.login-banner-img { width: 100%; height: 100%; object-fit: cover; display: block; }

.campo-senha { position: relative; }
.campo-senha .icone {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  opacity: 0.7;
  pointer-events: none;
}
.input-senha { padding-left: 42px; padding-right: 42px; }
.campo-senha .icone.olho {
  left: auto;
  right: 12px;
  cursor: pointer;
  pointer-events: auto;
}
</style>
